import type { CellValueChangedEvent } from '@cmg/data-grid';
import { useCallback } from 'react';

import type { useUpdateRelationship } from '../../../../../components/shared-columns/hooks/useUpdateRelationship';
import type { InvestorCoverageRow } from '../InvestorCoverageGrid.model';

type UseCellValueChangedProps = {
  onUpdateRelationship: ReturnType<typeof useUpdateRelationship>;
};

export function useCellValueChanged({ onUpdateRelationship }: UseCellValueChangedProps) {
  return useCallback(
    ({ colDef, data, newValue }: CellValueChangedEvent<InvestorCoverageRow>) => {
      if (colDef.field === 'relationshipType') {
        void onUpdateRelationship({
          firmId: data.firmId,
          employeeId: data.employeeId,
          status: data.relationshipStatus,
          relationshipType: newValue,
        });
      }
      if (colDef.field === 'relationshipStatus') {
        void onUpdateRelationship({
          firmId: data.firmId,
          employeeId: data.employeeId,
          status: newValue,
          relationshipType: data.relationshipType,
        });
      }
    },
    [onUpdateRelationship]
  );
}
